import { Component, OnInit, Output,Input, EventEmitter } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-confirm-send-recharge',
  templateUrl: './confirm-send-recharge.component.html',
  styleUrls: ['./confirm-send-recharge.component.sass']
})
export class ConfirmSendRechargeComponent implements OnInit {
  @Input() idTransactionRecarga;
  @Input() idTransaction;
  @Input() total;
  @Input() totalPagar;
  public selectBan;
  @Input() subscriber;
  @Output() updateInitializeData = new EventEmitter();
  public allDate;
  constructor( private global: GlobalService,private router: Router) { }

  ngOnInit() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.subscriber = this.global.getSuscriberByDefault(this.selectBan);
    let fullDateNow = new Date();
    let actualDate = fullDateNow.getFullYear();
    let actualMonth: any = fullDateNow.getMonth() + 1;
    let actualDay: any = fullDateNow.getDate();
    let actualHour: any = fullDateNow.getHours();
    let minutes: any = fullDateNow.getMinutes();
    if (minutes.toString().length == 1) { minutes = "0" + minutes.toString(); }
    if (actualHour.toString().length == 1) { actualHour = "0" + actualHour.toString(); }
    if (actualDay.toString().length == 1) { actualDay = "0" + actualDay.toString(); }
    if (actualMonth.toString().length == 1) { actualMonth = "0" + actualMonth.toString(); }

    this.allDate = actualDate + "-" + actualMonth + "-" + actualDay + " " + actualHour + ":" + minutes;
  }
  printDiv = function(divName) {
    if(this.global.validateSession()===true){
      let divToPrint = document.getElementById(divName).innerHTML;
      let newWindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      newWindow.document.open();
      newWindow.document.write(`
      <html>
          <head>
            <title>Print tab</title>
            <style>
           
            </style>
          </head>
          <body onload="window.print();window.close()">${divToPrint}   
          </body>
        </html>
      `);
      newWindow.document.close();
    }
  }
  printDiv3 = function(divName) {
    if(this.global.validateSession()===true){
      var printContents = document.getElementById(divName).innerHTML;
      var mywindow = window.open('', 'new div', 'height=400,width=600');
        mywindow.document.write('<html><head><title></title>');
        mywindow.document.write('<link rel="stylesheet"href="confirm-send-recharge.component.sass" type="text/sass" />');
        mywindow.document.write(`
          <style>
            .green-confrm {
                width: 100%;
                height: auto;
                padding: 20px;
                float: left;
                background-color: #d2eb90;
                font-size: 18px;
                color: #222222;
                position: relative;
                padding-left: 77px;
            }
          </style>
        `);
        mywindow.document.write('</head><body >');
        mywindow.document.write(printContents);
        mywindow.document.write('</body></html>');
        mywindow.document.close();
        mywindow.focus();
        setTimeout(function(){mywindow.print();},1000);
        //mywindow.close();
        return true;
    }
  }
  printDiv2 = function(divName) {
    if(this.global.validateSession()===true){
      var printContents = document.getElementById(divName).innerHTML;
      var popupWin = window.open('', '_blank', 'width=300,height=300');
      popupWin.document.open();
      popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="confirm-send-recharge.component.sass" /></head><body onload="window.print()">' + printContents + '</body></html>');
      popupWin.document.close();
    }
  } 
  return(){
    this.router.navigate(['home']);
  }
}